 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		100: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"components-video_module-video_module","4":"ibdPage","6":"legacyIbdPage","8":"ad-AdContainer","9":"components-analytics-analytics","10":"components-feature_feed-feature_feed","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"list_page","23":"list_page_2024","24":"list_page_2025","25":"loginPage","26":"logoutPage","27":"magazineTagPage","28":"magazine_page","29":"myAccountPage","30":"newsletters_page_marketo","31":"notFoundPage","32":"offerPage","33":"playlistIndexPage","34":"playlistPage","35":"podcastPage","36":"post_page","37":"registerPage","38":"resetPasswordPage","39":"sitemapIndex","40":"sitemapPost","41":"splash_page","42":"splash_page_new","43":"stories","44":"subscribePage","45":"tagPage","46":"videoIndex","47":"videoPage","48":"views-containers-layouts-blank_layout-blank_layout","49":"views-containers-layouts-web_layout-web_layout","95":"MarketoNewsletterForm","96":"MicCarousel","97":"MicIcon","98":"MicMobileIconCarousel","99":"Success-SubmissionSuccess","101":"applications-most-innovative-companies","102":"brands_that_matter_2021","103":"brands_that_matter_page","104":"categoryLink","105":"components-ApplyPageImportantDates-ApplyPageImportantDates","106":"components-BackgroundHighlight-BackgroundHighlight","107":"components-BtmCmos-index","108":"components-BtmPastHonereesLogos-index","109":"components-MultiTabList-MultiTabList","110":"components-QuickCarousel-QuickCarousel","111":"components-StickyBar-StickyBar","112":"components-all_feed-all_feed","113":"components-categories","114":"components-config-config","115":"components-editor_highlights-editor_highlights","116":"components-finite_scroll","117":"components-footer-footer","118":"components-franchise_intro-franchise_intro","119":"components-ibd_category-ibd_category","120":"components-image-image","121":"components-magazine_archive-magazine_archive","122":"components-masthead-masthead","123":"components-mcp_section-mcp_section","124":"components-mic_card-mic_card","125":"components-mic_mobile_menu-mic_mobile_menu","126":"components-more-stories-component-more-stories-component","127":"components-newsletters-recaptcha","128":"components-notice","129":"components-podcast_tile-podcast_tile","130":"components-podcast_tile-podcast_tile_featured","131":"components-post-content-insert","132":"components-ranked","133":"components-recirc-recirc","134":"components-related_posts-related_posts","135":"components-related_slider-related_slider","136":"components-sectors_list-sectors_list","137":"components-social-social","138":"components-top_50-top_50","139":"components-top_50_shuffle-top_50_shuffle","140":"components-video_megatron-video_megatron","141":"containers-pages-list_landers-bwi-2020","142":"containers-pages-list_landers-ibd-2020","143":"containers-pages-list_landers-mic-2021","144":"content-innovation_festival_banner","145":"content-sponsor_bar","146":"fc-components-main-components","147":"fc-components-main-components-StickyBar-StickyBar","148":"fc-components-main-containers","149":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","150":"fc-components-main-containers-IbdLayout-IbdLayout","151":"fc-components-main-containers-MicLayout-MicLayout","152":"fc-components-main-containers-WciLayout-WciLayout","153":"fc-components-main-utils-ConditionalWrapper","154":"franchises-BtmApplyPage","155":"franchises-BwiApplyPage","156":"franchises-IbdApplyPage","157":"franchises-MicApplyPage","158":"franchises-NbttApplyPage","159":"franchises-WciApplyPage","160":"innovation_by_design_future_page","161":"innovation_by_design_page_franchise","162":"innovation_by_design_page_franchise_2023","163":"layouts","164":"layouts-mcp","165":"nav_main_menu-nav_main_menu","166":"package_article_list_entry","167":"packages-nav-package_sticky_nav","168":"post-content-sidebar","169":"topics"}[chunkId]||chunkId) + "." + {"1":"3ff63b04fc1003cae583","2":"e26b2df0d6040eb26b5c","3":"1af278819eaedcfbf27b","4":"6e97806813c73f137fcd","5":"b7c74d2121b31a62c794","6":"3052bb970c1940a300e1","7":"ae0c6de209140b11b96c","8":"db98f07af373c010b176","9":"310a381ddad3d40700f6","10":"e62dd8c53ca5cfe96e80","11":"0a7fe1985900ea72e13a","12":"4f6fb82d87fcff32ae3c","13":"3b6eabc3ee1a58f9a9cf","14":"2b4c140511b2036cf38b","15":"e8d659978c67831a9315","16":"c96997a5245f387ca2a2","17":"3c849e93cca320b661d4","18":"aef52050efc33753bf74","19":"7c703bf428ecee51fe1a","20":"6301430fd8bfc2f1681f","21":"0293d075491a0be8452a","22":"8696e4f77ea035765dc7","23":"41a0042d1fba88af3efb","24":"1d44c7f0b65d9275d007","25":"29f0fbded6c4b6688120","26":"f11e456a126d5ad2243e","27":"2055b9abec5afecadc48","28":"a1b80d5845b8cd0dd650","29":"fd61ce524c22802a901d","30":"9873cebe539d24437f4f","31":"633acd482275095c1217","32":"baa9f26cb5229f597587","33":"7a4daef7be03703182bc","34":"be1367db1441f8e9c9eb","35":"7486ad1478efb044ca2b","36":"f3dc0196ea3c5add50da","37":"0864acd96ebf4ce40004","38":"088e7dc6090ca01d38eb","39":"e254bdd743580ba7ba03","40":"5d085b13acb97aa26c18","41":"4154d32762b39fcf6a6c","42":"ea517af127965ef80cc9","43":"15ef44e06703946344d9","44":"4f0f43c2fa888609590e","45":"b3b0863c65b745b45357","46":"b1fd9341945224176830","47":"15b22f69cdec117d1941","48":"ab2a6b2f0392b9227ed2","49":"89340067621d08d45496","50":"03c3daf81d5b9bc5d296","51":"31888b94c05615bfd2e1","52":"14587a7a39ab893bc320","53":"94cdfca7246d6f823745","54":"98ed30d9d354ad645651","55":"2e1877d5ad8b41c00c69","56":"b053129ad97950a0fca9","57":"8ef0db248c94aa816309","58":"6d98db0f1762532972c1","59":"918286491c25f1d36a95","60":"7de284603a008cfd6fb3","61":"beb10baa5ef113e51005","62":"814d831ab404d3b7edfb","63":"6dac87008b9da62815c3","64":"924d363ca71c90ade746","65":"36159ec5a94f9bfa6b47","66":"f7a3aae905467b63aef2","67":"d8484c74faa46399c082","68":"037be6b2da29868d8867","69":"ac370a2bba6aa170755d","70":"280db95c3e7fd70fad2d","71":"ba181368479624155cf1","72":"f918a6ef655d8aaac7fd","73":"623a14ddcb649510d331","74":"dedf936febca9407efa5","75":"59dfcaa7925558ba3593","76":"531dbee9a12bb6273151","77":"d6acea9445784003d22a","78":"f0efa872a29344140510","79":"4c09a4cb99736d6510d1","80":"705cd91d6c5a15728e56","81":"aed76c3de0701c3b4900","82":"af2ff55684fd58366ceb","83":"a25437e4d766d12ed71f","84":"16e8bebbd93ccc7ed1a8","85":"f861b83fb1dc4e735c0b","86":"c35f9a917378386847b1","87":"6100a01d089137a27395","88":"8961205fc5a4cdbb96f6","89":"427426c9f849b3b6110f","90":"768d4727ae945d66d7c1","91":"def543ff34a0c725b20c","92":"bc512f4ecd1d35cb79aa","93":"1caffa2e0c958adbb2d2","94":"267ee1b233ba64f88c8e","95":"76315b0aae888fa75250","96":"9ff728b938e91be91f36","97":"db4c0d6007c41da61d44","98":"b2302d76de0f2d00c8f2","99":"c768cdbafeb8e706ddf0","101":"fb96978725e8b516d2e5","102":"de843663a9ca5f0ee926","103":"ca42dbe317bed02633bb","104":"6e9c5022149f4c6c1986","105":"12004f5b8998f24b86c4","106":"0b0c443a996754071b9e","107":"bc80b699d65a86037df7","108":"5bf9b3d6d375c8e9a636","109":"28f140781c684ad33a06","110":"dd1dda11ad00377d9b89","111":"aa68c41b3f706398cece","112":"46e7c09905f352a29c55","113":"e6d0063e9467cc6ed5c1","114":"3a788950763646000a31","115":"7e38b2305e99cbf1010d","116":"5a6e85f588d05b68551a","117":"ab2ff1a60bfb3ff4feec","118":"0d0da8448c9d7696a87f","119":"1ea28177a5bc7e55d088","120":"a837b0abe1436cc8ba30","121":"79de5a8834498e959396","122":"ad08dc8777b14ae73560","123":"22198ce0850ff83aafdf","124":"5ea5fed9a0d36684faf5","125":"f35ee8bf0faa5588042b","126":"247a654b6a7fe303b63e","127":"2429f849ba7458baabee","128":"07c76071cc7f7bdfe4ea","129":"e11bec9a9bed107a7d7a","130":"5079859eaaabc9bad8fa","131":"15d1e5ed6d762de45787","132":"71f59ff16d8ba3e6f9f4","133":"9da0d1cdabd714338408","134":"65b87bcd2e4cdd4e6396","135":"2b57c683476bd85b8ece","136":"760f30d4bf222b5e5546","137":"68b23825f532f4634b38","138":"e34aa22f78f0978c049a","139":"5eab9e345ae17216089b","140":"5bad172a4d073f4e7a58","141":"5f1ebeae3c421d406b02","142":"813b8e2f2434e378dcf4","143":"128380e420f1cb1c04ce","144":"cf4cb92e218ba9199258","145":"2a7972b9a230d71bb9a8","146":"ce5e15f8d7bdd952beeb","147":"d03a6534e9f6db3166cd","148":"49b883023d4d02c874df","149":"7e7cbbdb487296edb0bc","150":"843429f48aa88aca3b44","151":"baaa30a45842d3d556f6","152":"f6d5d3d13d71e17910c7","153":"6ca4a101a2e0638e335e","154":"59779ea062a61d005a45","155":"61984504593f46605ec4","156":"f22f27fd5ba3fa31fb63","157":"40836492f20a2d4dced5","158":"61662e618bdb936b98db","159":"66cbf974de32bf7c390e","160":"38317b2ef4cadf732c1d","161":"95eec369a91d58d7f935","162":"ac389b9f623e8abfefa4","163":"64c06852d405a9953729","164":"ca7d52fe9d4b58f5518d","165":"f1c690f4df402fbf9867","166":"b491021b61d69c7a682f","167":"a0f4047ec8840bd0abad","168":"f50d2db975761a75e7e6","169":"1fd5da14a5756d258e1e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([764,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
